const ConfigurationAdminsitrateValidator = (t) => {
  let regexs = {
    emailRegex: new RegExp(/^[a-zA-ZñÑ0-9._-]+@([a-zA-Z0-9._-]+\.)+[\w-]{2,}$/)
  }

  let validators = {
    emailValidator: (value) => {
      if (value !== '' && value !== undefined) {
        if (value.length > 0) {
          return (regexs.emailRegex.test(value) ? "" : t('configuration.administrate.action.messageErrorCurrentEmail'))
        }
      } else {
        return t('configuration.administrate.textValidator.email')
      }
    }
  }

  return validators
}
export { ConfigurationAdminsitrateValidator as default }
